import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";
import { queryClient } from "@/lib/queryClient";

/**
 * PATCH /users/me — Batch 27f.
 *
 * All fields optional; send only what changed. Backend accepts the new
 * `theme` field which mirrors the `users.theme` column. The legacy
 * `name` field is GONE; identity changes go through `first_name` /
 * `last_name`.
 */
interface UpdateProfileInput {
  first_name?: string;
  last_name?: string;
  email?: string;
  theme?: "light" | "dark" | "system";
}

interface UpdateProfileResponse {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  theme?: "light" | "dark" | "system";
}

export function useUpdateProfile() {
  return useMutation<UpdateProfileResponse, ApiError, UpdateProfileInput>({
    mutationFn: async (input) => {
      const r = await apiClient.patch<UpdateProfileResponse>("/users/me", input);
      return r.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
    },
  });
}

interface ChangePasswordInput {
  current_password: string;
  new_password: string;
}

export function useChangeMyPassword() {
  return useMutation<{ message: string }, ApiError, ChangePasswordInput>({
    mutationFn: async (input) => {
      const r = await apiClient.post<{ message: string }>(
        "/users/me/change-password",
        input,
      );
      return r.data;
    },
  });
}
